import React from 'react';
import { Box } from '@indeed/ifl-components';
import { ServiceDegradationBannerUI } from '@indeed/messaging-react';
import { isInProctorGroup } from 'utils/proctorUtils';
import { ProctorTestNames, ProctorCommonGroupValues } from 'proctor';

const bannerWrapperSx = {
    width: '100%',
    '@media (min-width: 480px)': {
        backgroundColor: 'neutral.200',
    },
} as const;

const ServiceDegradationBanner = (): JSX.Element | null => {
    if (
        !isInProctorGroup(
            ProctorTestNames.COMMSEXP_JOBSEEKER_SERVICE_DEGRADATION_BANNER,
            ProctorCommonGroupValues.ACTIVE
        )
    ) {
        return null;
    }

    return (
        <Box sx={bannerWrapperSx}>
            <ServiceDegradationBannerUI />
        </Box>
    );
};

export default ServiceDegradationBanner;
